const cellColors = {
    1: "#FFE49F", // Ждёт звонка
    2: "#FDFFB3", // Назначено собеседование
    5: "#D0F4E3", // Принят на стажировку
    7: "#D0F4E3", // Направлен на стажировку
    4: "#FFE6F2", // Отказано
    13: "#FFE6F2", // Кандидат отказался
    12: "#E1EDFF", // Назначено тестирование
    default: "#dfe4ef",
};

const statusItemColors = {
    1: "#FDD46A", // Ждёт звонка
    2: "#FBF45B", // Назначено собеседование
    5: "#AAF4D1", // Принят на стажировку
    7: "#AAF4D1", // Направлен на стажировку
    4: "#FFC8E2", // Отказано
    13: "#FFC8E2", // Кандидат отказался
    12: "#BED8FF", // Назначено тестирование
};

export default {
    data() {
        return {
            cellColors,
        };
    },
    methods: {
        getStatusColor(status) {
            return this.cellColors[status];
        },
        getItemStatusColor(status) {
            return statusItemColors[status];
        },
    },
};
